module.exports = __webpack_public_path__ + "img/3OOx6OO.d9244818.svg";